// src/pages/designer/DesignerReferral.jsx
import React, { useState } from "react";
import { useAuth } from "../../hooks/useAuth";
import { submitReferral } from "../../lib/db";
import { Btn, Field, Input, Toast } from "../../components/UI";

export default function DesignerReferral() {
  const { profile } = useAuth();
  const [form, setForm] = useState({ clientName:"", description:"", budget:"", brands:"", timing:"", notes:"" });
  const [toast, setToast] = useState({ msg:"", type:"success" });
  const [loading, setLoading] = useState(false);
  const set = k => e => setForm(f => ({ ...f, [k]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.clientName) { setToast({ msg:"Client name is required.", type:"error" }); return; }
    setLoading(true);
    try {
      await submitReferral({
        designerUid:  profile.uid,
        designerName: profile.name,
        clientName:   form.clientName,
        description:  form.description,
        budget:       Number(form.budget) || null,
        brands:       form.brands,
        timing:       form.timing,
        notes:        form.notes,
      });
      setForm({ clientName:"", description:"", budget:"", brands:"", timing:"", notes:"" });
      setToast({ msg:"Referral submitted! Our team will be in touch with your client shortly.", type:"success" });
    } catch (err) {
      setToast({ msg: err.message, type:"error" });
    } finally { setLoading(false); setTimeout(() => setToast({ msg:"" }), 5000); }
  };

  return (
    <div>
      <Toast msg={toast.msg} type={toast.type} onClose={() => setToast({ msg:"" })} />
      <div style={{ padding:"36px 48px 0" }}>
        <h1 style={{ fontFamily:"'Cormorant Garamond',serif", fontSize:36, fontWeight:300 }}>Submit a Referral</h1>
        <p style={{ fontSize:13, color:"var(--mid)", marginTop:4 }}>Send a client to our showroom — we'll handle the rest and credit your commission</p>
      </div>
      <div style={{ padding:"24px 48px 48px", maxWidth:640 }}>
        <div style={{ background:"var(--warm-white)", border:"1px solid var(--border)", borderRadius:4, padding:28 }}>
          <form onSubmit={handleSubmit}>
            <Field label="Client / Project Name *">
              <Input value={form.clientName} onChange={set("clientName")} placeholder="Henderson Residence – Master Bath" required />
            </Field>
            <Field label="Project Description">
              <Input value={form.description} onChange={set("description")} placeholder="Full bathroom remodel, interested in faucets and tub filler" />
            </Field>
            <div style={{ display:"flex", gap:14, flexWrap:"wrap" }}>
              <Field label="Estimated Budget ($)" half>
                <Input type="number" value={form.budget} onChange={set("budget")} placeholder="15000" />
              </Field>
              <Field label="Best Time to Contact" half>
                <Input value={form.timing} onChange={set("timing")} placeholder="Weekday mornings" />
              </Field>
            </div>
            <Field label="Preferred Brands / Products">
              <Input value={form.brands} onChange={set("brands")} placeholder="Interested in Waterstone, open to Brizo" />
            </Field>
            <Field label="Additional Notes">
              <Input value={form.notes} onChange={set("notes")} placeholder="Any special requirements or context for our team" />
            </Field>
            <div style={{ background:"var(--gold-pale)", border:"1px solid rgba(184,150,90,0.25)", borderRadius:2, padding:"12px 16px", fontSize:12, color:"#8A6830", marginBottom:20, lineHeight:1.7 }}>
              <strong>How it works:</strong> Once you submit, our team will reach out to your client. When they place an order, your {profile?.commissionRate || 8}% commission will be applied automatically.
            </div>
            <Btn type="submit" variant="gold" size="lg" disabled={loading}>{loading ? "Submitting…" : "Submit Referral"}</Btn>
          </form>
        </div>
      </div>
    </div>
  );
}
